import React from 'react';
import { useMedia } from 'react-use';
import iconInfo from './ic_info.svg';
import style from './block.module.scss';
import { defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableImg, EditableText } from '@smartfire/components';
import { ReactComponent as SmartfireIcon } from '../assets/smartfire_icone.svg';

const InspectorLazy = React.lazy(() => import('./Inspector'));
function Block({
    title1,
    title2,
    text,
    buttonText,
    buttonLink,
    imageMobile,
    imageDesktop,
    titleIcon,
    type,
    file,
    external,
}) {
    const { isEditing } = useEditor();
    const isWide = useMedia(`(min-width: ${style.mobileBreakpoint})`);
    useInspectorControl(InspectorLazy, []);

    let rel = '';
    if (external && rel === '') {
        rel = 'noopener noreferrer';
    }

    return (
        <div className={style.block}>
            <div className={style.headerImage}>
                {(isEditing || ((isWide || (!isWide && !imageMobile)) && imageDesktop)) && (
                    <EditableImg className={style.img} smartProp="imageDesktop" />
                )}
                {!isEditing && !isWide && imageMobile && (
                    <img className={style.img} src={imageMobile.url} alt={imageMobile.alt} />
                )}
            </div>
            <div className={style.content}>
                <div className={style.container}>
                    {(titleIcon || isEditing) && (
                        <div className={style.titleIcon}>
                            <EditableImg className={style.img} smartProp="titleIcon" />{' '}
                        </div>
                    )}
                    <div>
                        {(isEditing || title1) && (
                            <EditableText
                                tagName="h1"
                                placeholder="ajouter un titre"
                                smartProp="title1"
                                allowedFormats={['advanced/color']}
                            />
                        )}
                        {(isEditing || (title2 && isWide)) && (
                            <EditableText tagName="h2" placeholder="ajouter un sous-titre" smartProp="title2" />
                        )}
                    </div>
                </div>
                {title2 && !isWide && (
                    <EditableText tagName="h2" placeholder="ajouter un sous-titre" smartProp="title2" />
                )}
                <div className={style.text}>
                    {(isEditing || text) && (
                        <EditableText className={style.textContent} placeholder="ajouter un texte" smartProp="text" />
                    )}
                    <a
                        href={isEditing ? '!#' : type ? (file ? file.url : null) : buttonLink ? buttonLink : null}
                        onClick={(e) => isEditing && e.preventDefault()}
                        {...(external ? { target: '_blank', rel } : {})}
                    >
                        {(isEditing || (buttonText && buttonLink)) && (
                            <div className={style.iconLink}>
                                {' '}
                                <img src={iconInfo} alt="info" />{' '}
                                <EditableText
                                    tagName="span"
                                    className={style.iconText}
                                    placeholder="ajouter un texte au bouton"
                                    smartProp="buttonText"
                                />{' '}
                            </div>
                        )}
                    </a>
                </div>
            </div>
        </div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        imageDesktop: smartProps.image.withDefault({}),
        imageMobile: smartProps.image.withDefault({}),
        title1: smartProps.string.withDefault(''),
        title2: smartProps.string.withDefault(''),
        text: smartProps.string.withDefault(''),
        buttonText: smartProps.string.withDefault(''),
        buttonLink: smartProps.string.withDefault(''),
        titleIcon: smartProps.image.withDefault({}),
        file: smartProps.object.withDefault({}),
        external: smartProps.bool.withDefault(false),
        type: smartProps.bool.withDefault(false), //false: link - true: file
    },
    setup: {
        title: 'Page Header',
        icon: SmartfireIcon,
    },
});
